'use client'

import React, { useContext } from 'react'
import Image from 'next/image'
import { SpacerBase } from '../../atoms/GridSystem'
import { Paragraph, Heading } from '../../atoms/Typography/Typography.component'
import LinkWrapper from '../../atoms/LinkWrapper/LinkWrapper.component'
import Tag from '../../atoms/Tag/Tag.component'
import Button from '../../atoms/Button/Button.component'
import { MouseContext } from '../../../contexts/Mouse.context'
import * as S from './BentoBoxCaseElement.styles'
import { NormalizedCardUseCasesData } from '../../../models/molecules/CardUseCases'
import { useTranslations } from 'next-intl'

const BentoBoxCaseElement = ({
  title,
  description,
  href,
  image,
  tags,
  colorScheme,
}: NormalizedCardUseCasesData) => {
  const { cursorChangeHandler, cursorChangeColorScheme } = useContext(MouseContext)
  const t = useTranslations()

  return (
    <S.BentoBoxCaseElement colorScheme={colorScheme}>
      <S.BentoBoxCaseElementContent colorScheme={colorScheme}>
        <S.BentoBoxCaseElementUpperContent>
          {tags && tags.length > 0 && (
            <S.BentoBoxCaseElementTags>
              <Tag items={tags} />
            </S.BentoBoxCaseElementTags>
          )}
          <S.BentoBoxCaseElementTexts>
            {title && (
              <Heading content={title} typo={'headingXL'} weight={'medium'} />
            )}
            {description && (
              <Paragraph content={description} typo={'paragraphLG'} />
            )}
          </S.BentoBoxCaseElementTexts>
        </S.BentoBoxCaseElementUpperContent>

        <LinkWrapper href={`${href}`}>
          <Button
            label={t('bentoBoxCase.viewCaseStudy')}
            variant="primary"
            iconEnd="arrow-right"
            inheritedColorScheme={colorScheme}
          />
        </LinkWrapper>
      </S.BentoBoxCaseElementContent>

      {image?.src && (
        <LinkWrapper href={`${href}`}>
          <S.BentoBoxCaseElementImage
            onMouseEnter={() => {
              cursorChangeHandler('hovered');
              cursorChangeColorScheme(colorScheme);
            }}
            onMouseLeave={() => {
              cursorChangeHandler('');
              cursorChangeColorScheme(null);
            }}
          >
            <Image src={image?.src} alt={image?.alt || ''} fill />
          </S.BentoBoxCaseElementImage>
        </LinkWrapper>
      )}
    </S.BentoBoxCaseElement>
  )
}

export default BentoBoxCaseElement

